import { useState } from "react";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { StatisticPanels } from "../../Components/StaticticsPanels/StatisticsPanel";
import { Card } from "primereact/card";
import { StatisticPanelsProps } from "../../Components/StaticticsPanels/StatisticsPanel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const LabelsDashboard = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [statsCards, setStatsCards] = useState<StatisticPanelsProps>({
    cards: [
      {
        header: "Total Labels",
        tooltip: "Videos that have not been claimed",
        value: "?",
        id: "total-labelsLabels",
      },
      {
        header: "New Labels",
        tooltip: "Videos that have been claimed",
        value: "?",
        id: "new-labelsLabels",
      },
    ],
  });

  const labelDashboardTabs = [
    {
      label: "Brands",
      icon: "pi pi-exclamation-circle",
    },

    {
      label: "Languages",
      icon: "pi pi-times-circle",
    },
    {
      label: "Non Dialogue Languages",
      icon: "pi pi-times-circle",
    },
  ];

  const nonDialogueLanguages = [
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Thai",
      ND_Label: "ND_LAN_Thai",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Dutch",
      ND_Label: "ND_LAN_Dutch",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Greek",
      ND_Label: "ND_LAN_Greek",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Hindi",
      ND_Label: "ND_LAN_Hindi",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Tamil",
      ND_Label: "ND_LAN_Tamil",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Arabic (Unknown Dialect)",
      ND_Label: "ND_LAN_Arabic",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "French",
      ND_Label: "ND_LAN_French",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "German",
      ND_Label: "ND_LAN_German",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Hebrew",
      ND_Label: "ND_LAN_Hebrew",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Korean",
      ND_Label: "ND_LAN_Korean",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Polish",
      ND_Label: "ND_LAN_Polish",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Chinese (Mandarin)",
      ND_Label: "ND_LAN_Chinese",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "English (American)",
      ND_Label: "ND_LAN_English",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "English (British)",
      ND_Label: "ND_LAN_English",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Italian",
      ND_Label: "ND_LAN_Italian",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Russian",
      ND_Label: "ND_LAN_Russian",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Spanish (Latin American)",
      ND_Label: "ND_LAN_Spanish",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Spanish (Castillian)",
      ND_Label: "ND_LAN_Spanish",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Tagalog",
      ND_Label: "ND_LAN_Tagalog",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Turkish",
      ND_Label: "ND_LAN_Turkish",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Japanese",
      ND_Label: "ND_LAN_Japanese",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Hungarian",
      ND_Label: "ND_LAN_Hungarian",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Bahasa Malayu (Malaysia)",
      ND_Label: "ND_LAN_Malaysian",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Bahasa Indonesia (Indonesian)",
      ND_Label: "ND_LAN_Indonesian",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Portuguese (Brazilian)",
      ND_Label: "ND_LAN_Portuguese",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Portuguese (European)",
      ND_Label: "ND_LAN_Portuguese",
    },
    {
      VideoLanguage: "Non Dialogue",
      ChannelLanguage: "Vietnamese",
      ND_Label: "ND_LAN_Vietnamese",
    },
  ];

  const brandLabels = [
    {
      Brand: "Brand",
      BrandLabel: "Exact Brand Label",
      SubBrandLabel: "Exact Sub-Brand Label",
    },
    {
      Brand: "Baby Einstein",
      BrandLabel: "B_2Kids",
      SubBrandLabel: "SB_Baby Einstein",
    },
    {
      Brand: "Furby",
      BrandLabel: "B_2Kids",
      SubBrandLabel: "SB_Furby",
    },
    {
      Brand: "GLOB",
      BrandLabel: "B_Alopra",
      SubBrandLabel: "SB_GLOB",
    },
    {
      Brand: "Animonsta",
      BrandLabel: "B_Animonsta",
      SubBrandLabel: null,
    },
    {
      Brand: "Blippi Wonders",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi Wonders",
    },
    {
      Brand: "Blippi",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi (core)",
    },
    {
      Brand: "Blippi - Amazon Original",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi (core)",
    },
    {
      Brand: "Blippi - Toy Play",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi (core)",
    },
    {
      Brand: "Blippi Job Show",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi (core)",
    },
    {
      Brand: "Blippi Roblox",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Blippi Roblox",
    },
    {
      Brand: "Juca",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Juca",
    },
    {
      Brand: "Meekah",
      BrandLabel: "B_Blippi",
      SubBrandLabel: "SB_Meekah",
    },
    {
      Brand: "Care Bears",
      BrandLabel: "B_CloudCo",
      SubBrandLabel: "SB_Care Bears",
    },
    {
      Brand: "Care Bears Moonbug",
      BrandLabel: "B_CloudCo",
      SubBrandLabel: "SB_Care Bears MB",
    },
    {
      Brand: "Kiwi and Strit",
      BrandLabel: "B_Copenhagen",
      SubBrandLabel: "SB_Kiwi and Strit",
    },
    {
      Brand: "Crayola",
      BrandLabel: "B_Crayola LLC",
      SubBrandLabel: "SB_Crayola",
    },
    {
      Brand: "Molcar",
      BrandLabel: "B_Dentsu Inc",
      SubBrandLabel: "SB_Molcar",
    },
    {
      Brand: "Little Baby Bum",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Little Baby Bum",
    },
    {
      Brand: "Little Baby Bus (My Little Red Bus)",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Little Baby Bus",
    },
    {
      Brand: "Playtime With Twinkle",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Play w Twinkle",
    },
    {
      Brand: "Lellobee",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Lellobee",
    },
    {
      Brand: "Lellobee City Farm",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Lellobee",
    },
    {
      Brand: "Mia\u0027s Magic Playground",
      BrandLabel: "B_LBB",
      SubBrandLabel: "SB_Mia",
    },
    {
      Brand: "Digley \u0026 Dazey",
      BrandLabel: "B_Digley \u0026 Dazey",
      SubBrandLabel: null,
    },
    {
      Brand: "Go Buster",
      BrandLabel: "B_Go Buster",
      SubBrandLabel: null,
    },
    {
      Brand: "Go Buster - YouTube Originals",
      BrandLabel: "B_Go Buster",
      SubBrandLabel: null,
    },
    {
      Brand: "KiiYii",
      BrandLabel: "B_KiiYii",
      SubBrandLabel: null,
    },
    {
      Brand: "The Sharksons",
      BrandLabel: "B_The Sharksons",
      SubBrandLabel: null,
    },
    {
      Brand: "Bananas In Pyjamas",
      BrandLabel: "B_Endemol Shine",
      SubBrandLabel: "SB_Bananas Pyjamas",
    },
    {
      Brand: "Mr. Bean",
      BrandLabel: "B_Endemol Shine",
      SubBrandLabel: "SB_Mr. Bean",
    },
    {
      Brand: "PC Bob",
      BrandLabel: "B_Endemol Shine",
      SubBrandLabel: "SB_PC Bob",
    },
    {
      Brand: "Nursery Rhymes 123",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_NR123",
    },
    {
      Brand: "Gecko\u0027s Garage",
      BrandLabel: "B_Gecko",
      SubBrandLabel: "SB_Gecko (core)",
    },
    {
      Brand: "Gecko\u0027s Garage Classics",
      BrandLabel: "B_Gecko",
      SubBrandLabel: "SB_Gecko (core)",
    },
    {
      Brand: "Gecko x Blippi",
      BrandLabel: "B_Blippi, B_Gecko",
      SubBrandLabel: "SB_Gecko x Blippi",
    },
    {
      Brand: "Dr Poppy",
      BrandLabel: "B_Dr Poppy",
      SubBrandLabel: null,
    },
    {
      Brand: "Toddler Fun Learning",
      BrandLabel: "B_TFL",
      SubBrandLabel: null,
    },
    {
      Brand: "Sidewalk Cops",
      BrandLabel: "B_Gabe and Garrett",
      SubBrandLabel: "SB_Sidewalk Cops",
    },
    {
      Brand: "Glove and Boots",
      BrandLabel: "B_Glove and Boots",
      SubBrandLabel: "SB_G\u0026B (core)",
    },
    {
      Brand: "The Ring-a-Tangs (Big Red Button) - New Look",
      BrandLabel: "B_Glove and Boots",
      SubBrandLabel: "SB_Ring-a-Tangs",
    },
    {
      Brand: "The Ring-a-Tangs (Big Red Button) - Old Look",
      BrandLabel: "B_Glove and Boots",
      SubBrandLabel: "SB_Ring-a-Tangs",
    },
    {
      Brand: "Baby Einstein Classics",
      BrandLabel: "B_Hello Einstein",
      SubBrandLabel: "SB_Baby Einstein",
    },
    {
      Brand: "I\u0027m A Dinosaur",
      BrandLabel: "B_Huminah Huminah",
      SubBrandLabel: "SB_I\u0027m A Dinosaur",
    },
    {
      Brand: "L\u0027il Stompers",
      BrandLabel: "B_IoM Media",
      SubBrandLabel: "SB_L\u0027il Stompers",
    },
    {
      Brand: "Squishville",
      BrandLabel: "B_Jazwares",
      SubBrandLabel: "SB_Squishville",
    },
    {
      Brand: "Lego Duplo",
      BrandLabel: "B_Lego",
      SubBrandLabel: "SB_Lego Duplo",
    },
    {
      Brand: "Little Angel",
      BrandLabel: "B_Little Angel",
      SubBrandLabel: "SB_Lil Angel (core)",
    },
    {
      Brand: "Little World",
      BrandLabel: "B_Little Angel",
      SubBrandLabel: "SB_Little World",
    },
    {
      Brand: "Laugh and Learn Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Laugh \u0026 Learn MB",
    },
    {
      Brand: "Rescue Heroes Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Rescue Heroes MB",
    },
    {
      Brand: "Wonder Makers Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Wonder Makers MB",
    },
    {
      Brand: "Baby\u0027s First Friends",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_BFF",
    },
    {
      Brand: "Fisher Price Existing",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Fisher Price ",
    },
    {
      Brand: "Gus: The Itsy-Bitsy Knight",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Gus",
    },
    {
      Brand: "Imaginext",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Imaginext",
    },
    {
      Brand: "Kinderbot Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Kinderbot MB",
    },
    {
      Brand: "Laugh and Learn Existing",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Laugh \u0026 Learn",
    },
    {
      Brand: "Linkimals Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Linkimals MB",
    },
    {
      Brand: "Mega Bloks",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Mega Bloks",
    },
    {
      Brand: "Rescue Heroes Existing",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Rescue Heroes",
    },
    {
      Brand: "Rescue Heroes Tongal",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Rescue Heroes",
    },
    {
      Brand: "Thomas \u0026 Friends Existing",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Thomas",
    },
    {
      Brand: "Thomas \u0026 Friends Moonbug",
      BrandLabel: "B_Mattel",
      SubBrandLabel: "SB_Thomas MB",
    },
    {
      Brand: "Cozy Coupe",
      BrandLabel: "B_MGA",
      SubBrandLabel: "SB_Cozy Coupe",
    },
    {
      Brand: "Miko",
      BrandLabel: "B_Miko",
      SubBrandLabel: null,
    },
    {
      Brand: "Music Collaboration Specials",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Collab Specials",
    },
    {
      Brand: "Dreamy Baby Music",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Dreamy bb Music",
    },
    {
      Brand: "Duerme Mi Niño",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Duerme Mi Niño",
    },
    {
      Brand: "Baby Bunting",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Baby Bunting",
    },
    {
      Brand: "Gordy The Elf",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Gordy The Elf",
    },
    {
      Brand: "La La Lullaby",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_La La Lullaby",
    },
    {
      Brand: "Label Radio Edits",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Label Radio",
    },
    {
      Brand: "Label Team Videos",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Label Videos",
    },
    {
      Brand: "Moonbug Story Time",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_MB Story Time",
    },
    {
      Brand: "Sleepy Baby Sounds",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Sleepy Sounds",
    },
    {
      Brand: "Tastebuds",
      BrandLabel: "B_Audio Content",
      SubBrandLabel: "SB_Tastebuds",
    },
    {
      Brand: "MyGo! Original",
      BrandLabel: "B_MyGo! Original",
      SubBrandLabel: null,
    },
    {
      Brand: "Mila\u0027s Book of Magic Pets",
      BrandLabel: "B_Morphle",
      SubBrandLabel: "SB_Mila Magic Pets",
    },
    {
      Brand: "Morphle",
      BrandLabel: "B_Morphle",
      SubBrandLabel: "SB_Morphle (core)",
    },
    {
      Brand: "Morphle - Disney Original",
      BrandLabel: "B_Morphle",
      SubBrandLabel: "SB_Morphle (core)",
    },
    {
      Brand: "Morphle Classics",
      BrandLabel: "B_Morphle",
      SubBrandLabel: "SB_Morphle (core)",
    },
    {
      Brand: "Orphle the Magic Pet Sitter",
      BrandLabel: "B_Morphle",
      SubBrandLabel: "SB_Orphle",
    },
    {
      Brand: "Music House for Children",
      BrandLabel: "B_Music House",
      SubBrandLabel: null,
    },
    {
      Brand: "Action Pack",
      BrandLabel: "B_Netflix",
      SubBrandLabel: "SB_Action Pack",
    },
    {
      Brand: "Well Versed",
      BrandLabel: "B_Nickelodeon",
      SubBrandLabel: "SB_Well Versed",
    },
    {
      Brand: "Oddbods",
      BrandLabel: "B_Oddbods",
      SubBrandLabel: "SB_Oddbods (core)",
    },
    {
      Brand: "Minibods",
      BrandLabel: "B_Oddbods",
      SubBrandLabel: "SB_Minibods",
    },
    {
      Brand: "Antiks",
      BrandLabel: "B_Antiks",
      SubBrandLabel: null,
    },
    {
      Brand: "Insectibles",
      BrandLabel: "B_Insectibles",
      SubBrandLabel: null,
    },
    {
      Brand: "Rob The Robot",
      BrandLabel: "B_Rob The Robot",
      SubBrandLabel: null,
    },
    {
      Brand: "Pancake Manor",
      BrandLabel: "B_Pancake Manor",
      SubBrandLabel: null,
    },
    {
      Brand: "Pixel Kids",
      BrandLabel: "B_Pixel Zoo Pty",
      SubBrandLabel: "SB_Pixel Kids",
    },
    {
      Brand: "Pixel Zoo",
      BrandLabel: "B_Pixel Zoo Pty",
      SubBrandLabel: "SB_Pixel Zoo",
    },
    {
      Brand: "Sandaroo",
      BrandLabel: "B_Sandaroo",
      SubBrandLabel: "SB_Sandaroo (core)",
    },
    {
      Brand: "Toys Review Toys",
      BrandLabel: "B_Sandaroo",
      SubBrandLabel: "SB_Toys Review Toys",
    },
    {
      Brand: "Ruby Roo",
      BrandLabel: "B_Sandaroo",
      SubBrandLabel: "SB_Ruby Roo",
    },
    {
      Brand: "Patty Shukla",
      BrandLabel: "B_Shukla Music",
      SubBrandLabel: "SB_Patty Shukla",
    },
    {
      Brand: "Mighty Express",
      BrandLabel: "B_Spin Master",
      SubBrandLabel: "SB_Mighty Express",
    },
    {
      Brand: "Paw Patrol",
      BrandLabel: "B_Spin Master",
      SubBrandLabel: "SB_Paw Patrol",
    },
    {
      Brand: "Vida The Vet",
      BrandLabel: "B_Spin Master",
      SubBrandLabel: "SB_Vida The Vet",
    },
    {
      Brand: "Supa Strikas",
      BrandLabel: "B_Supa Strikas",
      SubBrandLabel: "SB_Supa (core)",
    },
    {
      Brand: "Supa Strikas: Rookie Season",
      BrandLabel: "B_Supa Strikas",
      SubBrandLabel: "SB_Rookie Season",
    },
    {
      Brand: "WonderBalls!",
      BrandLabel: "B_Synergy Media",
      SubBrandLabel: "SB_WonderBalls!",
    },
    {
      Brand: "Pea Kee Boo",
      BrandLabel: "B_Toikido",
      SubBrandLabel: "SB_Pea Kee Boo",
    },
    {
      Brand: "ARPO",
      BrandLabel: "B_ARPO",
      SubBrandLabel: null,
    },
    {
      Brand: "ARPO - Amazon Original",
      BrandLabel: "B_ARPO",
      SubBrandLabel: null,
    },
    {
      Brand: "T-Rex Ranch (ToyLabTV)",
      BrandLabel: "B_T-Rex Ranch",
      SubBrandLabel: null,
    },
    {
      Brand: "CoComelon Lane",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CoComelon Lane",
    },
    {
      Brand: "ABCkidTV",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM (core)",
    },
    {
      Brand: "Cece Time",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_Cece",
    },
    {
      Brand: "CoComelon",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM (core)",
    },
    {
      Brand: "CoComelon Classroom",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM Classroom",
    },
    {
      Brand: "CoComelon Melon Head Shorts",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM (core)",
    },
    {
      Brand: "CoComelon Small Scope",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM (core)",
    },
    {
      Brand: "CoComelon Toy Play",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_CCM (core)",
    },
    {
      Brand: "Cody Time",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_Cody",
    },
    {
      Brand: "JJ\u0027s Animal Time",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_Animal Time",
    },
    {
      Brand: "Nina Time",
      BrandLabel: "B_CoComelon",
      SubBrandLabel: "SB_Nina",
    },
    {
      Brand: "Baby Bao Panda",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Baby Bao Panda",
    },
    {
      Brand: "Baby Big Cheese",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Baby Big Cheese",
    },
    {
      Brand: "Baby Toot Toot",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Baby Toot Toot",
    },
    {
      Brand: "Kids Baby Club",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Kids Baby Club",
    },
    {
      Brand: "Little Treehouse",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Little Treehouse",
    },
    {
      Brand: "Little Tritans",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Little Tritans",
    },
    {
      Brand: "Super supremes",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Super supremes",
    },
    {
      Brand: "Zeek and Friends",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Zeek and Friends",
    },
    {
      Brand: "Bob the Train",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Bob the Train",
    },
    {
      Brand: "Bob the Train (Español)",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Bob the Train",
    },
    {
      Brand: "Boom Buddies",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Boom Buddies",
    },
    {
      Brand: "Bottle Squad",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Bottle Squad",
    },
    {
      Brand: "Farmees",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Farmees",
    },
    {
      Brand: "Junior Squad",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Junior Squad",
    },
    {
      Brand: "Kids Channel",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Kids Channel",
    },
    {
      Brand: "Kids TV",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Kids TV",
    },
    {
      Brand: "Little Eddie",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Little Eddie",
    },
    {
      Brand: "Loco Nuts Nursery Rhymes",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Loco Nuts",
    },
    {
      Brand: "Luke and Lily",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Luke and Lily",
    },
    {
      Brand: "Road Rangers",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Road Rangers",
    },
    {
      Brand: "Schoolies",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Schoolies",
    },
    {
      Brand: "Zoobees",
      BrandLabel: "B_USP Studios",
      SubBrandLabel: "SB_Zoobees",
    },
    {
      Brand: "VeeFriends",
      BrandLabel: "B_Vaynerwatt LLC",
      SubBrandLabel: "SB_VeeFriends",
    },
    {
      Brand: "Where\u0027s Chicky?",
      BrandLabel: "B_Xilam",
      SubBrandLabel: "SB_Where\u0027s Chicky?",
    },
    {
      Brand: "Om Nom Stories",
      BrandLabel: "B_Zeptolab",
      SubBrandLabel: "SB_Om Nom Stories",
    },
    {
      Brand: "Rainbocorns",
      BrandLabel: "B_Zuru",
      SubBrandLabel: "SB_Rainbocorns",
    },
    {
      Brand: "Smashers",
      BrandLabel: "B_Zuru",
      SubBrandLabel: "SB_Smashers",
    },
  ];

  const languageLabels = [
    {
      Language: "Non Dialogue",
      Label: "LAN_ND",
    },
    {
      Language: "Thai",
      Label: "LAN_Thai",
    },
    {
      Language: "Czech",
      Label: "LAN_Czech",
    },
    {
      Language: "Dutch",
      Label: "LAN_Dutch",
    },
    {
      Language: "Greek",
      Label: "LAN_Greek",
    },
    {
      Language: "Hindi",
      Label: "LAN_Hindi",
    },
    {
      Language: "Tamil",
      Label: "LAN_Tamil",
    },
    {
      Language: "Arabic (Modern Standard)",
      Label: "LAN_Arabic",
    },
    {
      Language: "Arabic (Unknown Dialect)",
      Label: "LAN_Arabic",
    },
    {
      Language: "Danish",
      Label: "LAN_Danish",
    },
    {
      Language: "French",
      Label: "LAN_French",
    },
    {
      Language: "French (Canadian)",
      Label: "LAN_French",
    },
    {
      Language: "French (Parisian)",
      Label: "LAN_French",
    },
    {
      Language: "German",
      Label: "LAN_German",
    },
    {
      Language: "Hebrew",
      Label: "LAN_Hebrew",
    },
    {
      Language: "Korean",
      Label: "LAN_Korean",
    },
    {
      Language: "Polish",
      Label: "LAN_Polish",
    },
    {
      Language: "Chinese",
      Label: "LAN_Chinese",
    },
    {
      Language: "Chinese (Mandarin)",
      Label: "LAN_Chinese",
    },
    {
      Language: "Chinese (Taiwan)",
      Label: "LAN_Chinese",
    },
    {
      Language: "American Sign Language",
      Label: "LAN_English",
    },
    {
      Language: "Audio Description English US",
      Label: "LAN_English",
    },
    {
      Language: "English (American)",
      Label: "LAN_English",
    },
    {
      Language: "English (British)",
      Label: "LAN_English",
    },
    {
      Language: "Vocal English American. English \u0026 Mandarin Subtitles",
      Label: "LAN_English",
    },
    {
      Language: "Finnish",
      Label: "LAN_Finnish",
    },
    {
      Language: "Italian",
      Label: "LAN_Italian",
    },
    {
      Language: "Latvian",
      Label: "LAN_Latvian",
    },
    {
      Language: "Russian",
      Label: "LAN_Russian",
    },
    {
      Language: "Spanish (Castillian)",
      Label: "LAN_Spanish",
    },
    {
      Language: "Spanish (Latin American)",
      Label: "LAN_Spanish",
    },
    {
      Language: "Swedish",
      Label: "LAN_Swedish",
    },
    {
      Language: "Tagalog",
      Label: "LAN_Tagalog",
    },
    {
      Language: "Turkish",
      Label: "LAN_Turkish",
    },
    {
      Language: "Croatian",
      Label: "LAN_Croatian",
    },
    {
      Language: "Estonian",
      Label: "LAN_Estonian",
    },
    {
      Language: "Japanese",
      Label: "LAN_Japanese",
    },
    {
      Language: "Romanian",
      Label: "LAN_Romanian",
    },
    {
      Language: "Hungarian",
      Label: "LAN_Hungarian",
    },
    {
      Language: "Icelandic",
      Label: "LAN_Icelandic",
    },
    {
      Language: "Bahasa Malayu (Malaysia)",
      Label: "LAN_Malaysian",
    },
    {
      Language: "Norwegian",
      Label: "LAN_Norwegian",
    },
    {
      Language: "Slovakian",
      Label: "LAN_Slovakian",
    },
    {
      Language: "Ukrainian",
      Label: "LAN_Ukrainian",
    },
    {
      Language: "Bahasa Indonesia (Indonesian)",
      Label: "LAN_Indonesian",
    },
    {
      Language: "Lithuanian",
      Label: "LAN_Lithuanian",
    },
    {
      Language: "Portuguese (Brazilian)",
      Label: "LAN_Portuguese",
    },
    {
      Language: "Portuguese (European)",
      Label: "LAN_Portuguese",
    },
    {
      Language: "Portuguese (Portugal) (DO NOT USE FOR NEW PROJECTS)",
      Label: "LAN_Portuguese",
    },
    {
      Language: "Vietnamese",
      Label: "LAN_Vietnamese",
    },
  ];

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: "Labels Dashboard",
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            model={labelDashboardTabs}
          />
        ),
      }}
    >
      <div
        style={{
          width: "96%",
          margin: "0 auto",
        }}
      >
        <StatisticPanels cards={statsCards.cards} />
        <Card>
          {activeIndex === 0 && (
            <DataTable value={brandLabels} size="small">
              <Column header={"Brand"} field="Brand" />
              <Column header={"BrandLabel"} field="BrandLabel" />
              <Column header={"SubBrandLabel"} field="SubBrandLabel" />
            </DataTable>
          )}

          {activeIndex === 1 && (
            <DataTable value={languageLabels} size="small">
              <Column header={"Language"} field="Language" />
              <Column header={"Label"} field="Label" />
            </DataTable>
          )}
          {activeIndex === 2 && (
            <DataTable value={nonDialogueLanguages} size="small">
              <Column header={"VideoLanguage"} field="VideoLanguage" />
              <Column header={"ChannelLanguage"} field="ChannelLanguage" />
              <Column header={"ND_Label"} field="ND_Label" />
            </DataTable>
          )}
        </Card>
      </div>
    </PageContainer>
  );
};

export default LabelsDashboard;
